import { useMemo, useRef, useState } from 'react'
import styles from './FilterBox.module.scss'
import {
    DotsThreeIcon,
    PencilSimpleIcon,
    BookmarkSimpleIcon,
    TrashIcon,
} from '@phosphor-icons/react'
import { ScoopMenu, ScoopMenuItem, ScoopText } from '../../../ui'

const OperatorMap = {
    Equals: 'is one of',
    NotEquals: 'is not one of',
    GreaterThan: 'is greater than',
    LessThan: 'is less than',
    GreaterThanOrEquals: 'is greater than or equal to',
    LessThanOrEquals: 'is less than or equal to',
    Like: 'contains',
    NotLike: 'does not contain',
}

export const FilterBox = ({ filter, number, handleRemove, handleEdit, handleSave }) => {
    const anchorEl = useRef(null)
    const [open, setOpen] = useState(false)

    const filterOperationString = useMemo(() => {
        if (!filter.filterValue) return null
        return filter.attributeName + ' ' + OperatorMap[filter.operator] + ' '
    }, [filter])

    const filterOptionsString = useMemo(() => {
        if (!filter.filterValue) return null
        return filter.filterValue.values
            .map((value, index) => (index > 0 ? `, ${value}` : value))
            .join('')
    }, [filter])

    const handleMenuClick = (action) => {
        switch (action) {
            case 'edit':
                handleEdit()
                break
            case 'save':
                handleSave()
                break
            case 'remove':
                handleRemove()
                break
            default:
                break
        }
        setOpen(false)
    }

    return (
        <>
            <div className={styles.container}>
                <div className={styles.header}>
                    <ScoopText className={`inter ${styles.headerText}`}>
                        {number}. {filterOperationString}
                    </ScoopText>
                    <button
                        ref={anchorEl}
                        className={styles.menuButton}
                        onClick={() => setOpen(true)}
                    >
                        <DotsThreeIcon size={20} weight="bold" />
                    </button>
                </div>
                <div className={styles.content}>
                    <ScoopText className={`inter ${styles.contentText}`}>
                        {filterOptionsString}
                    </ScoopText>
                </div>
            </div>
            <ScoopMenu open={open} anchorEl={anchorEl.current} onClose={() => setOpen(false)}>
                <ScoopMenuItem
                    onClick={() => handleMenuClick('edit')}
                    leftSection={<PencilSimpleIcon size={20} className={styles.menuIcon} />}
                >
                    Edit
                </ScoopMenuItem>
                <ScoopMenuItem
                    onClick={() => handleMenuClick('save')}
                    leftSection={<BookmarkSimpleIcon size={20} className={styles.menuIcon} />}
                >
                    Create Saved Filter
                </ScoopMenuItem>
                <ScoopMenuItem
                    onClick={() => handleMenuClick('remove')}
                    leftSection={<TrashIcon size={20} className={styles.menuIconDanger} />}
                >
                    <span className={styles.menuTextDanger}>Remove</span>
                </ScoopMenuItem>
            </ScoopMenu>
        </>
    )
}
